import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppConfig } from '@env/app-config';

/**
 * Bloquea una ruta fuera de `--configuration local` (tu propia máquina) — ni siquiera
 * "development" pasa (es un servidor compartido). Redirige a 404 en vez de a login: la ruta
 * no existe ahí, no es que falte iniciar sesión.
 *
 * Uso: rutas que no deben quedar accesibles en ningún ambiente desplegado, como el catálogo
 * de componentes de la dependencia (`/partnercore-components`).
 */
export const localOnlyGuard: CanActivateFn = () => {
  if (AppConfig.isLocal) return true;

  const router = inject(Router);
  return router.parseUrl('/404');
};
